import React from 'react';

/**
 * Returns a modified version of the component with its props preset to the
 * given default values.
 *
 * This is primarily useful for customizing wrappers for testing-library render()
 * calls, since initialProps are not supplied to wrappers in testing-library v16.
 *
 * @param Component
 * @param defaultProps
 * @returns A new component with the default props applied
 */
export function withDefaultProps<PropsType>(
  Component: React.FC<PropsType>,
  defaultProps: React.ComponentProps<typeof Component>
): React.FC<Partial<React.ComponentProps<typeof Component>>> {
  return (props) => <Component {...defaultProps} {...props} />;
}
